<template>
  <div id="app" class="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  components: {},

  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {},
};
</script>
<style>
</style>
<style lang="less" scoped>

</style>
